import axios from 'axios';
import config from '../config';
import querystring from 'query-string';

export const fetchToken = (username, password) =>
  axios.request({
    method: 'POST',
    url: `${config.AUTH_URL}/token`,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: querystring.stringify({
      username,
      password,
      grant_type: 'password',
    }),
  });



// WEBPACK FOOTER //
// ./src/api/auth.js